<template>
  <div v-if="show" 
       :class="[
         'p-4 mb-4 rounded-md', 
         isError ? 'bg-red-100 text-red-800 border border-red-300' : 
                  'bg-yellow-100 text-yellow-800 border border-yellow-300'
       ]">
    <div class="flex items-center">
      <svg v-if="isError" class="h-5 w-5 mr-2 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <svg v-else class="h-5 w-5 mr-2 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
      </svg>
      <span class="font-medium">{{ message }}</span>
    </div>
    <div v-if="details" class="mt-2 text-sm">
      {{ details }}
    </div>
    <div v-if="showRetryButton" class="mt-3">
      <button 
        @click="$emit('retry')" 
        class="px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50"
      >
        Retry
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'JobStatusNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    },
    details: {
      type: String,
      default: ''
    },
    showRetryButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['retry']
});
</script>